export const FETCH_SESSIONS_SUCCESS = "FETCH_SESSIONS_SUCCESS";
export const FETCH_SESSIONS_ERROR = "FETCH_SESSIONS_ERROR";

export const DELETE_SESSION_SUCCESS = "DELETE_SESSION_SUCCESS";
export const DELETE_SESSION_ERROR = "DELETE_SESSION_ERROR";

export const UPDATE_SESSION_SUCCESS = "UPDATE_SESSION_SUCCESS";
export const UPDATE_SESSION_ERROR = "UPDATE_SESSION_ERROR";

export const CREATE_SESSION_SUCCESS = "CREATE_SESSION_SUCCESS";
export const CREATE_SESSION_ERROR = "CREATE_SESSION_ERROR";